const actionType = {
    add: "add",
    edit: "edit",
    delete: "delete",
    view: "view"
}

export default actionType;